// Contacts CRM domain — referrers, professionals, sponsors.
import { API } from './_client';

export const contacts = {
  list: (opts = {}) => API.get('/contacts', { params: opts }).then((r) => r.data),
  get: (id) => API.get(`/contacts/${id}`).then((r) => r.data),
  create: (payload) => API.post('/contacts', payload).then((r) => r.data),
  update: (id, patch) => API.patch(`/contacts/${id}`, patch).then((r) => r.data),
  remove: (id) => API.delete(`/contacts/${id}`).then((r) => r.data),
  leaderboard: (limit = 10) => API.get('/contacts/summary/leaderboard', { params: { limit } }).then((r) => r.data),
};
